// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZHeM","selected":"styles_selected__3XhVA"};